import { Chip, ContentCard } from "@narmi/design_system";
import { useNavigate } from "react-router-dom";
import styles from "./GroupCard.module.css";

export const GroupCard = ({
  category,
  groupName,
  description,
  numberOfSettings,
}: {
  category: string;
  groupName: string;
  description: string;
  numberOfSettings: number;
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.cardWrapper}>
      <ContentCard
        kind="button"
        onClick={() => {
          navigate(
            `/configuration/institution_settings/categories/${encodeURIComponent(category)}/groups/${encodeURIComponent(groupName)}/subgroups`
          );
        }}
      >
        <div className="nds-typography margin--bottom">
          <div className={styles.title}>{groupName}</div>
          <div className={styles.description}>{description}</div>
        </div>
        <Chip
          label={`${numberOfSettings} ${numberOfSettings === 1 ? "setting" : "settings"}`}
          kind="primary"
        />
      </ContentCard>
    </div>
  );
};
